import React from "react";

function Footer(props) {
  return (
    <div className="footer">
      <p>Ⓒ Yogita Chaudhari 2021</p>
    </div>
  );
}

export default Footer;